import type { Site } from '../Site';

export const CountryHomesandInteriors: Site = {
  id: 'countryhandi',
  analyticsName: 'countryhandi',
  selector: '',
  logo: '',
  label: 'CountryHomesandInteriors',
  platform: '',
};
